<template>
  <div class="container-fluid autenticacao">
    <div>
      <div class="card">
        <div class="card-header">
          <div class="row">
            <div class="col col-xs-2">
              <h5 class="panel-title">Recibo de Retenção</h5>
            </div>
          </div>
        </div>
        <div id="topo" class="card-body">
          <div class="form-title-links">
            <span
              class="form-title"
            >Informe aqui o seu CPF/CNPJ e o número da Nota Fiscal para impressão do Recibo de Retenção</span>
          </div>

          <div class="p-field-radiobutton">
            <RadioButton
              id="radio1"
              name="documento"
              value="N"
              v-model="tipoValidacao"
              class="radio"
              tabindex="1"
            />
            <label for="radio1" class="p-radiobutton-label">NFS-e</label>

            <RadioButton
              id="radio2"
              name="chave"
              value="D"
              v-model="tipoValidacao"
              class="radio2"
              tabindex="2"
            />
            <label for="radio2" class="p-radiobutton-label">DAPS</label>
          </div>
          <br />
          <br />

          <InputText
            id="cpfCnpj"
            type="text"
            @blur="validarDocumento()"
            placeholder="CPF/CNPJ do prestador"
            autocomplete="off"
            tabindex="3"
            class="inputLogin links-tipoPessoa"
            v-model="documentoPrestador"
          />
          <br />
          <br />
          <InputText
            id="chave"
            type="text"
            placeholder="Número Nota Fiscal"
            autocomplete="off"
            tabindex="4"
            class="inputLogin links-tipoPessoa"
            v-model="numero"
          />

          <div class="botoes-avancar-voltar" style="margin-top: 15px;">
            <Button label="Voltar" type="submit"  class="btnVoltar" id="btnVoltar" @click="login()"  icon="pi pi-angle-left" :disabled="loading" />

            <Button label="Imprimir" type="submit"  class="btnAvançar" id="btnAutenticar" @click="visualizar()" icon="pi pi-angle-right" :disabled="loading" />
          </div>
        </div>
      </div>
    </div>

    <Dialog :header="tituloDialogSelecao" :visible.sync="showDialogSelecao"
            :style="{ width: '90vw', maxWidth: '1400px' }" :contentStyle="{ overflow: 'visible' }" :modal="true" :closable="false">
        <div style="background-color: #f8f9fa; padding: 10px 15px; margin-bottom: 10px; border-radius: 4px; border-left: 4px solid #007bff; font-size: 15px;">
          <i class="pi pi-info-circle" style="margin-right: 8px; color: #007bff;"></i>
          Foram encontrados <strong>{{registrosEncontrados.length}}</strong> registros com o número <strong>{{numero}}</strong>. Selecione o registro desejado para impressão do Recibo de Retenção.
        </div>
        <DataTable :value="registrosEncontrados" :paginator="true" :rows="5"
                   class="p-datatable-responsive" :autoLayout="true" style="min-width: 100%">
          <Column header="Imprimir" headerStyle="width: 70px" bodyStyle="text-align: center">
            <template #body="slotProps">
              <Button type="button" icon="pi pi-print" title="Imprimir"
                      @click="selecionarRegistro(slotProps.data)" />
            </template>
          </Column>
          <Column header="Número" headerStyle="width: 80px">
            <template #body="slotProps">
              <span class="p-column-title">Número</span>
              {{slotProps.data.numero}}
            </template>
          </Column>
          <Column header="Série" headerStyle="width: 80px" v-if="tipoSelecao === 'N'">
            <template #body="slotProps">
              <span class="p-column-title">Série</span>
              {{slotProps.data.serie}}
            </template>
          </Column>
          <Column header="Data Emissão" headerStyle="width: 110px">
            <template #body="slotProps">
              <span class="p-column-title">Data Emissão</span>
              {{slotProps.data.dataEmissao}}
            </template>
          </Column>
          <Column header="Prestador">
            <template #body="slotProps">
              <span class="p-column-title">Prestador</span>
              {{slotProps.data.documentoPrestador}} - {{slotProps.data.prestador}} 
            </template>
          </Column>
          <Column header="Tomador">
            <template #body="slotProps">
              <span class="p-column-title">Tomador</span>
              {{slotProps.data.documentoTomador}} - {{slotProps.data.tomador}}
            </template>
          </Column>
          <Column header="Valor" headerStyle="width: 100px">
            <template #body="slotProps">
              <span class="p-column-title">Valor</span>
              {{slotProps.data.valorServico}}
            </template>
          </Column>
        </DataTable>
      <div style="display: flex; justify-content: flex-start; padding: 5px 0;">
            <Button @click="cancelarSelecao()" type="button" label="Fechar"
                    class="p-button-primary mr-2 p-button-danger" icon="pi pi-times" />
      </div>
    </Dialog>
  </div>
</template>

<script>
import AutenticacaoService from "../services/nfse/autenticacao.service";
import DnsClienteService from "../services/nfse/dns.cliente.service";
import Util from "../Utils/util";

export default {
  data() {
    return {
      documentoPrestador: null,
      numero: null,
      tipoValidacao: null,
      loading: false,
      idCliente: null,
      anoAtual: null,
      showDialogSelecao: false,
      registrosEncontrados: [],
      registroSelecionado: null,
      tituloDialogSelecao: '',
      tipoSelecao: null
    };
  },

  mounted() {
    document.getElementById("cpfCnpj").focus();
    var d = new Date();
    this.anoAtual = d.getFullYear();
    setTimeout(async () => {
      this.processando(true);
      let host = window.location.hostname;
      this.dnsCliente = await DnsClienteService.get(host);
      if (
        this.dnsCliente &&
        this.dnsCliente.data &&
        this.dnsCliente.data.idCliente
      ) {
        this.idCliente = this.dnsCliente.data.idCliente;
      }
      this.processando(false);
    }, 250);
  },

  created() {
    this.limparDados();
    this.documentoPrestador = this.$route.query.cpfCnpj;
    this.numero = this.$route.query.numero;
    this.tipoValidacao = this.$route.query.tipo ? this.$route.query.tipo : "N";
  },

  methods: {
    limparDados() {
      this.documentoPrestador = null;
      this.numero = null;
      this.tipoValidacao = "N";
      this.loading = false;
      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;
      this.tituloDialogSelecao = '';
      this.tipoSelecao = null;
    },

    login() {
      this.$router.push("/login");
    },

    visualizar() {
      this.processando(true);
      if (
        this.documentoPrestador &&
        this.numero &&
        this.tipoValidacao &&
        this.idCliente
      ) {
        AutenticacaoService.validaReciboRetencao(
          this.tipoValidacao,
          this.documentoPrestador,
          this.numero,
          this.idCliente
        )
          .then(
            response => {
              var retorno = response.data;
              if (retorno.multiplo) {                
                this.registrosEncontrados = retorno.registros;
                this.tipoSelecao = retorno.tipo;
                this.tituloDialogSelecao = retorno.tipo === 'N'
                  ? 'Selecione a Nota Fiscal'
                  : 'Selecione a DAPS';
                this.showDialogSelecao = true;
              }
            },
            error => {
              this.$root.$emit("alert:warn", error.response.data);
            }
          )
          .then(() => {
            this.processando(false);
          });
      }
    },

    selecionarRegistro(registro) {
      var idNfs = registro.id;
      var tipo = this.tipoValidacao;
      var idCliente = this.idCliente;

      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;

      AutenticacaoService.imprimirReciboRetencaoPorId(tipo, idCliente, idNfs);
    },

    cancelarSelecao() {
      this.showDialogSelecao = false;
      this.registrosEncontrados = [];
      this.registroSelecionado = null;
    },

    processando(show) {
      if (show) {
        this.loading = true;
        this.$root.$emit("loading:show");
      } else {
        this.loading = false;
        this.$root.$emit("loading:hide");
      }
    },

    validarDocumento() {
      var validar = false;
      validar = Util.validarCPFCNPJ(this.documentoPrestador);

      if (!validar && this.documentoPrestador) {
        console.log(validar);
        this.$root.$emit("alert:error", "CPF/CNPJ inválido!");
      }
    }
  }
};
</script>

<style src="../assets/css/links-autenticacao-recibo-credenciamento-contribuintes.css"></style>